module.exports = __webpack_public_path__ + "img/lv.e0713417.svg";